import { passThroughAxios } from './passThrough.axios'

export default {
  async getOrderError(quoteId) {
    const response = await passThroughAxios.get(`car-orders/${quoteId}/error`)
    return response.status === 204 ? null : response.data
  },
}
